<template>
  <div class="page">    
    <img class="page__bg1" src="https://file.liuyamed.com/Fl_H5w8LADfvVufMA3O6Iv5ErkiT" alt="">
    <img class="page__bg2" src="https://file.liuyamed.com/Fl_H5w8LADfvVufMA3O6Iv5ErkiT" alt="">    
    <img class="page__bg3" src="https://file.liuyamed.com/Fl_H5w8LADfvVufMA3O6Iv5ErkiT" alt="">
    <img class="page__bg4" src="https://file.liuyamed.com/Fl_H5w8LADfvVufMA3O6Iv5ErkiT" alt="">

    <div class="section">
      <div class="section__header">
        <div class="section__header__icon">1</div>
        <div class="section__header__text">冲刺组队模考</div>
      </div>
      <div class="section__content">
        <p class="section__content__line">11月5日 群内第一次模考开始</p>
        <p class="section__content__line">11月7日 早10:00线上开放</p>
        <p class="section__content__line">11月8日 群内第二次模考开始</p>
        <p class="section__content__line">11月10日 早10:00线上开放</p>
        <p class="section__content__line">如有更多模考安排见群内通知</p>
        <p class="section__content__line">模拟试卷电子版开放日期同线上开放时间，保存下方二维码微信扫一扫进群</p>
      </div>
      <div class="section__footer">
        <div class="section__footer__imgwrap" @click="onClickGroupCode">
          <img class="section__footer__img" src="https://file.liuyamed.com/Fkd5_AswLCLoePK5iTHObP5GMtbt" alt="">
        </div>        
        <div class="section__footer__imgdesc">微信群二维码</div>
        <router-link to="/online-exam">
          <div class="section__footer__btn">查看线上模考入口</div>
        </router-link>        
      </div>
    </div>

    <div class="section">
      <div class="section__header">
        <div class="section__header__icon">2</div>
        <div class="section__header__text">答题闯关送抱枕</div>
      </div>
      <div class="section__content">
        <p class="section__content__line">即日起至医考二试开始前，临床执业医师、临床执业助理答题闯关每日排名前两名送抱枕，活动期间每人限领一个抱枕。</p>
        <p class="section__content__line">答题闯关在柳芽天使app-题库-临床执业医师题库/临床执业助理题库-答题闯关查看</p>        
      </div>
      <div class="section__footer">        
        <div style="height: 25px"></div>
        <router-link to="/test-game">
          <div class="section__footer__btn">查看答题闯关入口</div>
        </router-link>        
      </div>
    </div>

    <div class="section">
      <div class="section__header">
        <div class="section__header__icon">3</div>
        <div class="section__header__text">冲刺资料</div>
      </div>
      <div class="section__content">
        <p class="section__content__line">完整冲刺资料整理好了，快来下载！</p>        
        <div class="datum">
          <div class="datum__header">
            <div class="datum__header__left">冲刺资料</div>
            <div class="datum__header__right" @click="onNavigateToMedicalData">
              <div>查看全部</div>
              <img src="../assets/right_arrow.png" alt="">
            </div>            
          </div>
          <div class="datum__content">
            <div class="datum__content__item">
              <img src="https://file.liuyamed.com/FtSZP0jlRC_rQ5qQ-74678HjfuvF" alt="">
            </div>
            <div class="datum__content__item">
              <img src="https://file.liuyamed.com/FtSZP0jlRC_rQ5qQ-74678HjfuvF" alt="">
            </div>
            <div class="datum__content__item">
              <img src="https://file.liuyamed.com/FtSZP0jlRC_rQ5qQ-74678HjfuvF" alt="">
            </div>
            <div class="datum__content__item" style="margin-right: 0">
              <img src="https://file.liuyamed.com/FtSZP0jlRC_rQ5qQ-74678HjfuvF" alt="">
            </div>
          </div>
        </div>
      </div>      
    </div>

    <div class="section">
      <div class="section__header">
        <div class="section__header__icon">4</div>
        <div class="section__header__text">小组推荐</div>
      </div>
      <div class="section__content">
        <p class="section__content__line">小组内精选内容准备了冲刺必备经验内容</p>
        <p class="section__content__line">学习打卡，有问题互相答，组队资料更全面</p>      
        <div class="circle">
          <img class="circle__logo" src="https://file.liuyamed.com/FrwCdg4sslDbftVP0ya3LZV6_l6Y" alt="">
          <div class="circle__info">
            <div class="circle__info__name">医考加油站</div>
            <div class="circle__info__join">27640人加入</div>
          </div>
          <div class="circle__btn" @click="onNavigateToGroup">
            进入小组
          </div>
        </div>
      </div>
      <div class="section__footer">    
        <div style="height: 20px"></div>            
        <div class="section__footer__btn" @click="onSubmit">发现更多小组</div>        
      </div>
      <div class="section__footer qrcodes">
        <div>
          <div class="section__footer__imgwrap">
            <img class="section__footer__img" @click="onClickGroupCode" src="https://file.liuyamed.com/Fkd5_AswLCLoePK5iTHObP5GMtbt" alt="">          
          </div>        
          <div class="section__footer__imgdesc">微信群二维码</div>
        </div>
        <div>
          <div class="section__footer__imgwrap">
            <img class="section__footer__img" @click="onClickGroupCode" src="https://file.liuyamed.com/Fv7uxV6aDMkoLx1uchdRRz2nmbM1" alt="">          
          </div>        
          <div class="section__footer__imgdesc">小柳芽医考二维码</div>
        </div>
        <div>
          <div class="section__footer__imgwrap">
            <img class="section__footer__img" @click="onClickGroupCode" src="https://file.liuyamed.com/FnG0h-OU7dACiZEiaii_6AkTVpNO" alt="">          
          </div>        
          <div class="section__footer__imgdesc">柳芽天使公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import LY from '../utils/liuya-js-sdk'

const MESSAGE_TYPE = {
  SHOW_POSTER: 1,
  NAVIGATE_TO: 2,
  NAVIGATE_BACK: 3,
  SWITCH_TAB: 4,
  TITLE: 5,
  SHARE_MESSAGE: 6 
}

export default {
  name: 'Home',
  data () {
    return {
      isWechat: false,
      isApp: false,
      isMiniProgram: false
    }
  },
  mounted() {
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWechat = true      
    }
    if (ua.match(/miniProgram/i) == 'miniprogram') {
      this.isMiniProgram = true
    }
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      this.isApp = true
      document.title = '医考二试冲刺'

      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: MESSAGE_TYPE.SHARE_MESSAGE,
        title:'临床执业医师二试冲刺模考开始啦～',
        description: '冲刺模考，答题闯关有奖，冲刺资料下载',
        webpageUrl: 'http://web.liuyangel.com',        
        thumbImageUrl: 'https://file.liuyamed.com/FqObwE4yC-L8zh2s-112P-7Ns1nT',
        shareType: '1'
      }))
    }
    LY.setWechatShare({
      title: '临床执业医师二试冲刺模考开始啦～', // 分享标题
      desc: '冲刺模考，答题闯关有奖，冲刺资料下载', // 分享描述
      link: 'http://web.liuyangel.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://file.liuyamed.com/FqObwE4yC-L8zh2s-112P-7Ns1nT', // 分享图标
    })
    // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    //   wx.updateAppMessageShareData({ 
    //     title: '临床执业医师二试冲刺模考开始啦～', // 分享标题
    //     desc: '冲刺模考，答题闯关有奖，冲刺资料下载', // 分享描述
    //     link: 'http://web.liuyangel.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //     imgUrl: 'https://file.liuyamed.com/FqObwE4yC-L8zh2s-112P-7Ns1nT', // 分享图标
    //     success: function () {
    //       // 设置成功          
    //     }
    //   })
    //   wx.updateTimelineShareData({ 
    //     title: '临床执业医师二试冲刺模考开始啦～', // 分享标题
    //     link: 'http://web.liuyangel.com', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //     imgUrl: 'https://file.liuyamed.com/FqObwE4yC-L8zh2s-112P-7Ns1nT', // 分享图标
    //     success: function () {
    //       // 设置成功
    //     }
    //   })
    // });
  },  
  methods: {
    onSubmit() {
      if (this.isApp) {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 4,
            value: '/pages/tabbar/group'
          }))
        }
      } else if (this.isMiniProgram) {
        wx.miniProgram.postMessage({
          data : {
            action: 'appLink'
          }
        })
        wx.miniProgram.navigateBack()
      } else {
        window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.liuyangel"
      }
    },
    onNavigateToMedicalData() {
      if (this.isApp) {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 2,
            url: '/pages/clinic/medicalData'
          }))
        }
      } else if (this.isMiniProgram) {
        wx.miniProgram.postMessage({
          data : {
            action: 'appLink'
          }
        })
        wx.miniProgram.navigateBack()
      } else {
        window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.liuyangel"
      }
    },
    onNavigateToGroup() {
      if (this.isApp) {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 2,
            url: '/pages/circle/index?topicType=1'
          }))
        }
      } else if (this.isMiniProgram) {
        wx.miniProgram.postMessage({
          data : {
            action: 'appLink'
          }
        })
        wx.miniProgram.navigateBack()
      } else {
        window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.liuyangel"
      }
    },
    onClickGroupCode(e) {  
      let title = ''
      let tips = ''
      if (/Fkd5_AswLCLoePK5iTHObP5GMtbt/.test(e.target.src)) {
        title = '21医考二试冲刺模考群'
        tips = '微信扫码进群统一模考'
      }
      if (/Fv7uxV6aDMkoLx1uchdRRz2nmbM1/.test(e.target.src)) {
        title = '小柳芽医考二维码'
        tips = '扫码关注'
      }
      if (/FnG0h-OU7dACiZEiaii_6AkTVpNO/.test(e.target.src)) {
        title = '柳芽天使公众号'
        tips = '扫码关注'
      }
      LY.clickQRCode({
        title, tips, url: e.target.src,
        urls: [
          "https://file.liuyamed.com/Fkd5_AswLCLoePK5iTHObP5GMtbt",
          "https://file.liuyamed.com/Fv7uxV6aDMkoLx1uchdRRz2nmbM1",
          "https://file.liuyamed.com/FnG0h-OU7dACiZEiaii_6AkTVpNO"
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>

@import "../style/basepage.scss";

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue